module.exports = __webpack_public_path__ + "fba9770f32a90e6f3566bc3b27289444.pdf";